<template>
  <!-- postech component view (stub) -->

  <!-- Screw pile worksheet -->

  <hr class="mb-3" />

  <!-- collapse area button -->
  <div class="mb-3">
    <button
      class="btn btn-outline-primary dropdown-toggle collapse-btn w-100"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#screwpile-worksheet"
      aria-expanded="false"
      aria-controls="screwpile-worksheet"
      @click="toggleVisible"
    >
      Show Screwpile Worksheet:
    </button>
  </div>

  <div v-if="isVisible" class="container collapse" id="screwpile-worksheet">
    <div class="my-10">
      <h4>Screwpile Worksheet:</h4>
    </div>
    <div class="row mb-3">
      <!--FormListbox :name="'Climatic Site'" :options="allSites" :displayOptions="displayOptions" v-model:selected="selectedSite"></FormListbox-->
      <!--div class="debug">
          <p>selectedSite = {{ selectedSite }}</p>
          <p>code = {{ code }}</p>
        </div>-->
      <div class="form-row">
        <MyForm :title="'Climatic Notes'">
          <template v-slot:fields>
            <div>
              <FormSelect
                :name="'Climatic Site'"
                :options="provincialSites"
                :displayOptions="displayOptions"
                v-model:selected="selectedSite"
              ></FormSelect>
              <FormTextArea
                :name="'Climatic Data'"
                :rows="20"
                :cols="40"
                v-model="climaticData"
              ></FormTextArea>
            </div>

            <div>
              <FormTextArea
                :name="'Climatic Notes'"
                :rows="24"
                :cols="40"
                v-model="climaticNotes"
              ></FormTextArea>
              <FormBtn :name="'copy'" @clicked="copyClimaticNotes"></FormBtn>
            </div>
          </template>
        </MyForm>
        <SeismicFetch :lat="gps.lat" :lon="gps.lon"></SeismicFetch>
      </div>
    </div>

    <PostechNotesSimple :location="currentProject.name"></PostechNotesSimple>
  </div>

  <div class="debug">
  <p>province = {{ province }}</p>
  <p>gps = {{ gps }}</p>
  <p>selected Site 2 = {{ selectedSite }}</p>
  <!--p>provincial sites = {{ provincialSites }}</p-->
  <!--p> allsites=  {{ allSites }}</p-->
</div>

</template>

<script setup lang="ts">
import { ref, computed, isReactive } from 'vue'
import { useClimaticStore, useProjectStore, usePostechStore } from '@/stores'
import {
  FormListbox,
  FormInput,
  FormSelect,
  FormTextArea,
  FormBtn,
  MyForm
} from '@/components/form'
import { storeToRefs } from 'pinia'
import { Province } from '@/types/types'
import PostechNotesSimple from './Postech-notes-simple.vue'
import SeismicFetch from '@/components/Seismic-fetch.vue'
import { useCurrentProject } from '@/composables/Current-project'

//const projectStore = useProjectStore()
//const { currentProject } = storeToRefs(projectStore)
const { currentProject } = useCurrentProject();
//const province = ref(currentProject.value.province)
const province = computed (() =>{
  return currentProject.value.province;
})
//const gps = ref(currentProject.value.gps)
const gps = computed (()=>{
  return currentProject.value.gps;
})

const climaticStore = useClimaticStore()

//const allSites = await climaticStore.getAllSites();
const { allSites } = storeToRefs(climaticStore);
//const allSites = climaticStore.allSites
//const selectedSite = ref(
const selectedSite = computed(()=>{
  return climaticStore.getNearestSites(province.value, gps.value.lat, gps.value.lon, 1)
});
//const selectedSite = ref(allSites[0]);
//only need to display sites in current province
const provincialSites = computed(() => {
  return allSites.value.filter((site) => {
    return site.province == province.value
  })
})
const displayOptions = computed(() => {
  return provincialSites.value.map((site) => {
    return site.municipality
  })
})
/*
const isVisible = computed(()=>{
  return false;
})*/
const isVisible = ref(false)
function toggleVisible() {
  isVisible.value = !isVisible.value
}

const climaticNotes = computed(() => {
  return `DESIGN LOADS			
LOCATION: ${selectedSite.value.lookup}			
DESIGN CODE: ${code.value}			
IMPORTANCE CATEGORY: NORMAL			
DEAD LOADS:			
	ROOF : 0.72kPa		
	FLOOR / DECK: 0.5kPa		
	WALLS: 0.5kPa		
ENVIRONMENTAL LOADS:			
	GROUND SNOW LOAD (Ss): ${selectedSite.value.Ss}kPa		
	RAIN LOAD: (Sr): ${selectedSite.value.Sr}kPa			
LIVE LOADS:			
	WIND LOADS (q1/50): ${selectedSite.value.q50}kPa	
	OPEN TERRAIN		
	FLOOR LIVE LOAD: 1.91kPa		
EARTHQUAKE LOADING:			
	Sa(0.2) = ${selectedSite.value.Sa02}	
	Sa(0.5) = ${selectedSite.value.Sa05}			
	Sa(1.0) = ${selectedSite.value.Sa1}		
	Sa(2.0) = ${selectedSite.value.Sa2}	
	Sa(5.0) = ${selectedSite.value.Sa5}		
	Sa(10.0)= ${selectedSite.value.Sa10}		
	PGA = ${selectedSite.value['PGA']}		
	PGV = ${selectedSite.value['PGV']}`
})

const climaticData = computed(() => {
  return `GPS = ${selectedSite.value.gps.lat}, ${selectedSite.value.gps.lon}
Ss = ${selectedSite.value.Ss}kPa		
Sr = ${selectedSite.value.Sr}kPa					
q1/50 = ${selectedSite.value.q50}kPa				
Sa(0.2) = ${selectedSite.value.Sa02}	
Sa(0.5) = ${selectedSite.value.Sa05}			
Sa(1.0) = ${selectedSite.value.Sa1}		
Sa(2.0) = ${selectedSite.value.Sa2}	
Sa(5.0) = ${selectedSite.value.Sa5}		
Sa(10.0)= ${selectedSite.value.Sa10}		
PGA = ${selectedSite.value['PGA']}		
PGV = ${selectedSite.value['PGV']}`
})

const designCodes = [
  { prov: 'AB', code: 'NBCC 2023 Alberta Edition' },
  { prov: 'BC', code: 'BCBC 2024' },
  { prov: 'SK', code: 'NBCC 2020' },
  { prov: 'MB', code: 'NBCC 2020' },
  { prov: 'ON', code: 'OBC 2024' },
  { prov: 'NB', code: 'NBCC 2020' },
  { prov: 'NS', code: 'NBCC 2020' }
]

const code = computed(() => {
  //const province = Province.value;
  return designCodes
    .filter((item) => {
      return item.prov === province.value
    })
    .map((item) => {
      return item.code
    })[0]
})

/**
 * utility function to copy the textarea content to clipboard on button click
 *
 */
function copyClimaticNotes() {
  console.log('postech worksheet copyClimaticNotes()...')

  let copyText = climaticNotes.value
  // Get the text field
  //var copyText = document.getElementById("projectName").innerText;
  //let copyText = element.value;
  // Copy the text inside the text field
  navigator.clipboard.writeText(copyText)
  // Alert the copied text
  //alert("Copied the text: " + copyText);
  console.log(copyText + ' copied to clipboard')
  //toast(copyText + " copied to clipboard");
}
</script>
